<template>
  <div class="count-money">
    <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/26/94/rB8LrWWDydWAGSG9AAVhXhKCBjI150.png" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
  .count-money {
    img {
      width: 375px;
      height: 231px
    }
   
  }
</style>